export default {
    items: [],
    currentPage: 0,
    totalsPages: 0,
    nextPageUrl: undefined,
    loaderEnabled: false,
    firstPageUrl: undefined,
    onlyMine: false,
    isMaximized: false,
};
